/* eslint-disable jsx-a11y/anchor-is-valid */
import '../App.css';
import { useState } from 'react';
import EstonianFlag from '../flags/ee.svg';
import UKFlag from '../flags/gb.svg';
import RussianFlag from '../flags/ru.svg';
import { Button, Input, Radio, Checkbox } from 'antd';
import Swal from 'sweetalert2'
import { DatePicker } from "react-rainbow-components";
import { CheckCircleFilled } from '@ant-design/icons'
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import TextArea from 'antd/es/input/TextArea';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const tz = "Europe/Tallinn"

const Russian = ({ availableDates, csrfTokenState, getCallToForm, getAvailableDates }) => {
  dayjs.locale('ru');
  dayjs.extend(customParseFormat)

  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [birthday, setBirthday] = useState(new Date('01-01-2000'));
  const [selectedLanguage, setSelectedLanguage] = useState('eesti');
  const [savedReservation, setSavedReservation] = useState(false);
  const [savedReservationNoDate, setSavedReservationNoDate] = useState(false);
  const [emailVerified, setEmailVerified] = useState(null);
  const [description, setDescription] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [checkBoxChecked, setCheckboxChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const options = [
    { label: 'эстонский', value: 'eesti' },
    /* { label: 'русский', value: 'vene' }, */
    { label: 'английский', value: 'inglise' },
    /* { label: 'украинский', value: 'ukraina' }, */
  ];

  const onChange = ({ target: { value } }) => {
    setSelectedDate(null);
    setSelectedLanguage(value);
  };

  function onDateChange(date) {
    setBirthday(date);
  }

  const onCheckboxChange = (e) => {
    setCheckboxChecked(e.target.checked);
  };
  
  function selectAvailableDate() {
    const fullName = name + ' ' + lastName;
    if (selectedDate === 'no-date') {
      fetch(`/broneering/broneeri/api/v1/guest/no-select`, {
        method: 'POST',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-csrf-token": csrfTokenState,
          },
          credentials: "include",
          body: `${JSON.stringify({
            name: fullName,
            email,
            phone,
            birthday: dayjs(birthday)?.tz(tz)?.format('DD.MM.YYYY'),
            language: selectedLanguage,
            description
          })}`
      })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false)
        if (!data.error) {
          setSavedReservationNoDate(true)
          setName('');
          setLastName('');
          setEmail('');
          setEmailVerified(null);
          setPhone('');
          setBirthday(null);
          setSelectedLanguage(null)
        }
      })
      .catch((err) => {
        setLoading(false)
        console.error('Error selecting available dates', err)
      })
    } else {
      if (!selectedDate?.id || !selectedLanguage || !selectedDate?.languages.some((language) => language === selectedLanguage)) return null
      fetch(`/broneering/broneeri/api/v1/guest/select/${selectedDate?.id}`, {
        method: 'POST',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-csrf-token": csrfTokenState,
          },
          credentials: "include",
          body: `${JSON.stringify({
            name: fullName,
            email,
            phone,
            birthday: dayjs(birthday)?.tz(tz)?.format('DD.MM.YYYY'),
            language: selectedLanguage,
            description
          })}`
      })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false)
        if (!data.error && data?.message !== 'date already reserved') {
          setSavedReservation(true)
          setName('');
          setLastName('');
          setEmail('');
          setEmailVerified(null);
          setPhone('');
          setBirthday(null);
          setSelectedLanguage(null)
        } else {
          if (data?.status === 'failure' && data?.message === 'date already reserved') {
            setSelectedDate(null)
            Swal.fire({
              title: "Извините!",
              icon: "info",
              html: `
                Этого времени больше нет, выберите другое время.
              `,
              showCloseButton: true,
              focusConfirm: false,
              confirmButtonText: `
                OK
              `,
              confirmButtonAriaLabel: "OK",

            });
            return getCallToForm().then((token) => getAvailableDates(token))
          }
        }
      })
      .catch((err) => {
        console.error('Error selecting available dates', err)
        setLoading(false)
      })
    }
  }

  const selectTheDate = (date) => {
    setSelectedDate(date)
  }

  const validateEmail = (email) => {
    if (!email?.length) {
      setEmailVerified(null)
    } else {
      const filterWhiteSpacesEmail = email.replace(/\s+/g, '');
      setEmailVerified(String(filterWhiteSpacesEmail)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ));
      setEmail(filterWhiteSpacesEmail)
    }
  };

  const getPDF = () => {
    fetch(`/broneering/broneeri/api/v1/guest/pdf/rus`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "x-csrf-token": csrfTokenState,
      },
      credentials: "include",
    })
      .then((res) => res?.arrayBuffer())
      .then(response => {
        if (response) {
          const file = new Blob([response], {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          console.error('No response from pdf')
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  const getDayOfWeek = (date) => {
    const day = dayjs(date)?.tz(tz).day()
    if (day === 0) return 'Во'
    if (day === 1) return 'По'
    if (day === 2) return 'Вт'
    if (day === 3) return 'Ср'
    if (day === 4) return 'Че'
    if (day === 5) return 'Пя'
    if (day === 6) return 'Су'
    return ''
  }

  if (savedReservation) return (
    <div className="joinOuterContainer">
      <div className="joinInnerContainer">
        <div style={{ fontSize: '27px', textAlign: 'center' }}>Вы записались на консультацию {dayjs(selectedDate?.startDate)?.tz(tz)?.format('DD.MM.YYYY HH:mm')?.slice(0, -5)} {dayjs(selectedDate?.startDate)?.tz(tz)?.format('DD.MM.YYYY HH:mm')?.slice(-5)}.</div>
        <div style={{ textAlign: 'center', fontSize: '18px', marginTop: '10px' }}>Подтверждение отправлено вам по электронной почте.</div>
        <div style={{ fontSize: '30px', textAlign: 'center', marginTop: '10px' }}><CheckCircleFilled style={{color: 'green', marginRight: '7px'}} /></div>
      </div>
    </div>
  )
  if (savedReservationNoDate) return (
    <div className="joinOuterContainer">
      <div className="joinInnerContainer">
        <div style={{ fontSize: '27px', textAlign: 'center' }}>Вы записались на консультацию.</div>
        <div style={{ textAlign: 'center', fontSize: '18px', marginTop: '10px' }}>Консультант свяжется с вами в ближайшее время.</div>
        <div style={{ fontSize: '30px', textAlign: 'center', marginTop: '10px' }}><CheckCircleFilled style={{color: 'green', marginRight: '7px'}} /></div>
      </div>
    </div>
  )
  return (
    <div className="App">
      <div id="registration-title-container">
        <div>
            <img alt="estonian" onClick={() => window.location.href = '/broneering/broneeri/est'} style={{marginRight: '10px', borderRadius: '3px', opacity: 0.4, cursor: 'pointer' }} width={30} src={EstonianFlag} />
            <img alt="english" onClick={() => window.location.href = '/broneering/broneeri/eng'} style={{marginRight: '10px', borderRadius: '3px', opacity: 0.4, cursor: 'pointer' }} width={30} src={UKFlag} />
            <img alt="russian" onClick={() => window.location.href = '/broneering/broneeri/rus'} style={{ borderRadius: '3px', cursor: 'pointer' }} width={30} src={RussianFlag}/>
        </div>
        <h1>Регистрация на консультацию</h1>
            
        <p>Мы предлагаем поддержку в решении повседневных проблем.</p>
        <p>Консультации бесплатны. За помощью могут обратиться все, у кого возникло напряжение и трудности в жизни и есть необходимость поговорить с кем - либо об этом.</p>
        <p>Наши консультанты слушают и помогают понять, как решить проблему.</p>
        <p>С вами беседует специалист по психическому здоровью с помощью видеомоста. Одна консультация длится до 60 минут. Мы проинструктируем Вас в технических деталях, чтобы встреча через Интернет прошла успешно. Речь не идет о терапии или психиатрической помощи, и услуга не заменит медицинскую помощь. Но можно обсудить с консультантом, как лучше помочь себе и куда обратиться за профессиональной помощью.</p>
        <p>Перед регистрацией ознакомьтесь с условиями использования услуги! Использование услуги считается согласием со всеми условиями.</p>
        <p>Через некоторое время после консультации Вам будет отправлено электронное письмо с запросом обратной связи. Мы будем благодарны, если вы ответите на это. Полученные отзывы мы используем для улучшения качества услуги.</p>
        <div style={{color: "#304c6d", cursor: 'pointer'}} onClick={() => getPDF()}><u>Ознакомьтесь с видеоконсультациями по оказанию антикризисной помощи и руководством по платформам</u>.</div>
      </div>

			
      <Input type="hidden" name="_token" value="icIYXsK0pUGahhlBRpYcZ1BfYs8T4pcX1PQYwlKh" />

      <div className="registration-form">
        <div>
          <div className="form-items">
            <label style={{display: 'flex'}}>Имя:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input onKeyDown={(event) => {
                  if (event.key === 'Enter') document.getElementById('last-name-input')?.focus()
                }} className={checkBoxChecked && !name?.length ? "input-no-length" : ""}  value={name} onChange={(e) => setName(e.target.value)} />
            </div>
          </div>
          <div className="form-items">
            <label style={{display: 'flex'}}>Фамилия:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input onKeyDown={(event) => {
                  if (event.key === 'Enter') document.getElementById('email-input')?.focus()
                }} id="last-name-input" className={checkBoxChecked && !lastName?.length ? "input-no-length" : ""}  value={lastName} onChange={(e) => setLastName(e.target.value)} />
            </div>
          </div>
          <div className="form-items">
            <label style={{display: 'flex'}}>Эл. почта:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input onKeyDown={(event) => {
                  if (event.key === 'Enter') document.getElementById('number-input')?.focus()
                }} id="email-input" className={checkBoxChecked && !email?.length ? "input-no-length" : ""} value={email} onChange={(e) => validateEmail(e.target.value)} />
            </div>
            <div style={{ fontWeight: 700, color: '#304c6d', width: '85%' }}>
              <small>Пожалуйста, введите адрес электронной почты, который вы активно используете. На этот адрес мы вышлем информацию о записи в электронном виде.</small>
            </div>
          </div>
        
          <div className="form-items">
            <label style={{display: 'flex'}}>Телефон:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input 
                type="number"
                onKeyDown={(event) => {
                  if (event.key === '.' || event.key === 'e' || event.key === ' ' || event.code === "Space" ) event.preventDefault()
                  if (event.key === 'Enter') document.getElementById('input-1')?.click()
                }}
                className={checkBoxChecked && !phone?.length ? "input-no-length" : ""} 
                id="number-input"
                onWheel={(e) => e.target.blur()}
                value={phone}
                onChange={(e) => setPhone(e.target.value?.replace(/[^\d]/g, ''))} 
              />
            </div>
          </div>
          <div className="form-items">
            <label style={{display: 'flex'}}>Дата рождения:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <DatePicker
                id="datePicker-1"
                value={birthday}
                onChange={onDateChange}
                maxDate={new Date()}
                locale='ru'
                label=""
                formatStyle="medium"
              />
            </div>
          </div>
          <div className="form-items">
            <label>Пожалуйста, опишите причину обращения в нескольких предложениях:</label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <TextArea id="reason-input" value={description} maxLength={500} onChange={(e) => setDescription(e.target.value)} />
            </div>
          </div>
        </div>
        <div className="form-items" style={{display: 'flex', marginTop: '7px'}}>
          <div style={{ marginRight: '10px', display: 'flex'}}>
            Язык:<div style={{color: 'red', marginLeft: '5px', marginRight:'10px'}}>*</div> 
          </div> 
          <Radio.Group options={options} onChange={onChange} value={selectedLanguage} />
        </div>
        
        <div style={{ maxHeight: '40%', overflow: 'auto' }}>
          <div style={{ height: '100%' }} className="form-items">
            <div className={checkBoxChecked && !selectedDate ? "red-text" : ""} style={{marginBottom: '20px', height: '20px', display: 'flex'}}>Подходящее время:<div style={{color: 'red', marginLeft: '5px'}}>*</div></div>
            <div style={{
              height: 'calc(100% - 20px)',
              overflow: 'auto'
            }}>
              <div id={selectedDate === 'no-date' ? "selected": "default"} style={{display: 'flex', marginBottom: '10px', cursor: 'pointer'}} onClick={() => selectTheDate('no-date')}>
                <div style={{ display: 'flex' }}>
                  Не нашел подходящего времени {selectedDate === 'no-date' ? <CheckCircleFilled style={{color: '#1777ff', marginLeft: '5px'}} /> : null}
                </div>
              </div>
              {!availableDates?.filter((date) => date?.languages?.some((language) => language === selectedLanguage))?.length ? <div style={{ fontWeight: 700, fontSize: '20px', color:'black', paddingTop: '10px' }}>Нет доступных времен</div> : null}
              {availableDates?.filter((date) => date?.languages?.some((language) => language === selectedLanguage))?.sort((a, b) => new Date(a.startDate) - new Date(b.startDate))?.map((date) => {
                return (
                  <div id={selectedDate?.id === date.id ? "selected": "default"} className={date?.client?.name?.length ? "reserved" : ""} style={{display: 'flex', marginBottom: '10px', cursor: 'pointer'}} onClick={() => !date?.client?.name?.length ? selectTheDate(date): null}>
                    <div style={{ display: 'flex' }}>
                    {getDayOfWeek(date?.startDate) + ' '} {dayjs(date?.startDate)?.tz(tz)?.format('DD.MM.YYYY HH:mm')} {selectedDate?.id === date.id ? <CheckCircleFilled style={{color: '#1777ff', marginLeft: '5px'}} /> : null}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <p style={{display: 'flex', justifyContent: 'center'}}><div style={{marginRight: '10px'}}><Checkbox onChange={onCheckboxChange}></Checkbox></div><a style={{color: "#304c6d"}} href="https://sotsiaalkindlustusamet.ee/ru/organizaciya-i-kontakty/prakticheskaya-informaciya/obrabotka-personalnykh-dannykh" target="_blank" rel="noreferrer" ><u>Я прочитал и согласен с принципами обработки персональных данных SKA</u></a></p>
        <div id="reservation-btn">
          <Button loading={loading} onClick={() => {setLoading(true); selectAvailableDate()}} disabled={!checkBoxChecked || !phone?.length || !/^\d+$/.test(phone) || !name?.length || !lastName?.length || !emailVerified || dayjs(birthday)?.tz(tz)?.format('DD.MM.YYYY')?.length !== 10 || (!selectedDate?.id?.length && selectedDate !== 'no-date') || !selectedLanguage?.length} size="large" type="primary"
          >
            Записаться на консультацию
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Russian;
